export type Env = {
  APP_VERSION: string;
  APP_API_BASE_URL: string;
  APP_PLAYER_ID: string;
  APP_FOOTER_TEXT: string;
  APP_DEFAULT_LANGUAGE: string;

  APP_DEFAULT_CONFIG_SOURCE?: string;
  APP_PLAYER_LICENSE_KEY?: string;

  APP_BODY_FONT?: string;
  APP_BODY_ALT_FONT?: string;

  APP_COGNITO_DOMAIN?: string;
  APP_COGNITO_CLIENT_ID?: string;
  APP_REDIRECT_URI?: string;
  APP_USER_POOL_ID?: string;
  APP_COGNITO_REGION?: string;
  APP_GRAPHQL_ENDPOINT?: string;
  APP_API_GRAPHQL_ENDPOINT?: string;
  APP_RELEASE_VERSION?: string;
  APP_BASE_URL?: string;
};

const env: Env = {
  APP_VERSION: '',
  APP_API_BASE_URL: 'https://cdn.jwplayer.com',
  APP_PLAYER_ID: 'M4qoGvUk',
  APP_FOOTER_TEXT: '',
  APP_DEFAULT_LANGUAGE: 'en',
  APP_RELEASE_VERSION: '1.0.62',

  APP_COGNITO_DOMAIN: '',
  APP_COGNITO_CLIENT_ID: '',
  APP_REDIRECT_URI: '',
  APP_USER_POOL_ID: '',
  APP_COGNITO_REGION: '',
  APP_GRAPHQL_ENDPOINT: '',
  APP_API_GRAPHQL_ENDPOINT: '',
};

export const configureEnv = (options: Partial<Env>) => {
  env.APP_VERSION = options.APP_VERSION || env.APP_VERSION;
  env.APP_API_BASE_URL = options.APP_API_BASE_URL || env.APP_API_BASE_URL;
  env.APP_PLAYER_ID = options.APP_PLAYER_ID || env.APP_PLAYER_ID;
  env.APP_FOOTER_TEXT = options.APP_FOOTER_TEXT || env.APP_FOOTER_TEXT;
  env.APP_DEFAULT_LANGUAGE = options.APP_DEFAULT_LANGUAGE || env.APP_DEFAULT_LANGUAGE;

  env.APP_DEFAULT_CONFIG_SOURCE ||= options.APP_DEFAULT_CONFIG_SOURCE;
  env.APP_PLAYER_LICENSE_KEY ||= options.APP_PLAYER_LICENSE_KEY;

  env.APP_BODY_FONT = options.APP_BODY_FONT || env.APP_BODY_FONT;
  env.APP_BODY_ALT_FONT = options.APP_BODY_ALT_FONT || env.APP_BODY_ALT_FONT;

  env.APP_COGNITO_DOMAIN = options.APP_COGNITO_DOMAIN || env.APP_COGNITO_DOMAIN;
  env.APP_COGNITO_CLIENT_ID = options.APP_COGNITO_CLIENT_ID || env.APP_COGNITO_CLIENT_ID;
  env.APP_REDIRECT_URI = options.APP_REDIRECT_URI || env.APP_REDIRECT_URI;
  env.APP_USER_POOL_ID = options.APP_USER_POOL_ID || env.APP_USER_POOL_ID;
  env.APP_COGNITO_REGION = options.APP_COGNITO_REGION || env.APP_COGNITO_REGION;
  env.APP_GRAPHQL_ENDPOINT = options.APP_GRAPHQL_ENDPOINT || env.APP_GRAPHQL_ENDPOINT;
  env.APP_API_GRAPHQL_ENDPOINT = options.APP_API_GRAPHQL_ENDPOINT || env.APP_API_GRAPHQL_ENDPOINT;
  env.APP_BASE_URL = options.APP_BASE_URL || env.APP_BASE_URL;
};

export default env;
